import EventTags from ".";

export const eventTagsRoutes = () => [
  {
    path: "/admin/event-tags",
    component: EventTags,
    layout: "admin",
    routeType: "admin",
    title: "Events Management",
  },
];
